import * as yup from "yup";

const noContactMsg = "A phone or email address is required";

const linkAppFormSchema = yup.object({
  firstName: yup.string().trim().required(),
  lastName: yup.string().trim().required(),
  phone: yup
    .string()
    .requireOneOfFields(["email", "phone"], noContactMsg)
    .validPhoneNumber("Invalid phone number"),
  email: yup
    .string()
    .requireOneOfFields(["email", "phone"], noContactMsg)
    .matches(/@/, "Requires a valid Email"),
  password: yup.string().trim().requireSibling("email").validPassword(),
  confirmPassword: yup
    .string()
    .trim()
    .test(
      "passwords-match",
      "Password and Confirm Password are Different",
      (value, context) => value === context.parent.password,
    ),
  linkCode: yup.string().trim().length(6, "Must be 6 characters").required(),
  terms: yup.boolean().oneOf([true], "Must be checked to submit"),
});

export { linkAppFormSchema };
